import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { Confirm } from 'src/app/models/confirm';
import { Reset } from 'src/app/models/reset';
import { SecurityService } from 'src/app/services/security.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { NgxMatPopoverComponent } from '@exalif/ngx-mat-popover';
import { GestorService } from 'src/app/services/gestor.service';
import { CedenteGestor } from 'src/app/models/cedentegestor';
import { Gestor } from 'src/app/models/gestor';
import { Cedente } from 'src/app/models/cedente';
import { Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resetar-senha',
  templateUrl: './resetar-senha.component.html',
  styleUrls: ['./resetar-senha.component.css']
})
export class ResetarSenhaComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private securityService: SecurityService,
    private alertService: NewAlertService,
    private gestorService: GestorService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  @ViewChild('popover') popover: NgxMatPopoverComponent;

  public MASKS = MASKS;

  public resetFormGroup: FormGroup;
  public confirmFormGroup: FormGroup;
  public resetCpf: string;
  public resetEmail: string;
  public step: number = 1;

  public currentUser: Auth;
  public cedenteGestor: CedenteGestor = new CedenteGestor(null, null, null, null, null, null, new Gestor(null, null, null, null, null), new Cedente(null, null, null, null, null, null), []);


  get formReset() { return this.resetFormGroup.controls; }
  public get formConfirm() { return this.confirmFormGroup.controls; }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.loadGestor();
    this.createFormConfirm();
  }

  private loadGestor() {
    this.gestorService.getGestor(this.currentUser.token.userReferenceId, this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.cedenteGestor = response.result;

          this.cedenteGestor.gestor.pessoa.documento = this.CompleteWithZero(
            this.cedenteGestor.gestor.pessoa.documento
          );

          this.onSubmitReset(new Reset(this.cedenteGestor.gestor.email, this.cedenteGestor.gestor.pessoa.documento));
        }
      },
      error => {
        this.alertService.error('Ocorreu um erro ao buscar as informações!');
      }
    );
  }

  public CompleteWithZero(documento: string) {
    if (!documento) {
      return;
    }

    let zeros = '';

    for (let i = 0; i < 11 - documento.toString().length; i++) {
      zeros += '0';
    }

    return documento;
  }

  createFormConfirm() {
    this.confirmFormGroup = this.formBuilder.group({
      token: new FormControl('', [
        Validators.required,
        Validators.minLength(6)
      ]),
      senha: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(100)
      ]),
      senhaConfirmacao: new FormControl('', [
        Validators.required,
        GenericValidator.mustMatch('senha')
      ]),
      email: new FormControl('', [
      ]),
      cpf: new FormControl('', [
      ])
    });
  }

  continueReset(reset: Reset) {
    this.step = 2;
    this.createFormConfirm();
    this.onSubmitReset(reset);
  }

  onSubmitReset(reset: Reset) {
    console.log(reset)
    reset.cpf = reset?.cpf?.toString().replace(/\D+/g, '').replace(' ', '');
    this.securityService.recuperar(reset).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.resetCpf = reset.cpf;
          this.resetEmail = reset.email;
          this.alertService.success(response.message, true);
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        //this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
        console.log(error);
        this.alertService.error('Ocorreu um erro ao tentar resetar a senha! Tente novamente mais tarde.');
      }
    );
  }

  continueConfirm(confirm: Confirm) {
    this.step = 2;
    this.onSubmitConfirm(confirm);
  }

  onSubmitConfirm(confirm: Confirm) {
    if (this.confirmFormGroup.valid) {
      confirm.cpf = this.resetCpf;
      confirm.email = this.resetEmail;
      this.securityService.confirmar(confirm).subscribe(
        response => {
          if (response.status === ApiError.Sucesso) {
            this.alertService.success(response.message);
            setTimeout(() => {
                this.router.navigate(['']);
            }, 2000);
          } else {
            this.alertService.error(response.message);
          }
        }, error => {
          this.confirmFormGroup.controls.token.setValue('');
          this.confirmFormGroup.controls.token.updateValueAndValidity();
          this.confirmFormGroup.controls.senha.setValue('');
          this.confirmFormGroup.controls.senha.updateValueAndValidity();
          this.confirmFormGroup.controls.senhaConfirmacao.setValue('');
          this.confirmFormGroup.controls.senhaConfirmacao.updateValueAndValidity();
          this.alertService.error('Erro ao alterar senha, tente novamente');
        }
      );
    }
  }

}
